import React, { useState, useEffect } from 'react';
import './GoldRateDropdown.css';
import axios from 'axios';

const GoldRateDropdown = ({ mobile }) => {
  const [prices, setPrices] = useState({ gold: null, silver: null });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const response = await axios.get('https://jerwishtech.site/v1/api/account/todayrate');
        setPrices({
          gold: response.data.Rate,
          silver: response.data.SILVERRATE,
        });
        setLoading(false);
      } catch (err) {
        console.warn('Primary API failed, falling back to local rates:', err.message);
        try {
          const localResponse = await axios.get(
            'https://app.nkvairamaaligai.com/api/v1/rates',
            { headers: { 'Content-Type': 'application/json' } }
          );
          const rates = localResponse.data;

          if (rates && rates.length > 0) {
            const latestRate = rates.sort(
              (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            )[0];
            setPrices({
              gold: latestRate.goldRate,
              silver: latestRate.silverRate,
            });
            setLoading(false);
          } else {
            setError('No rates available');
            setLoading(false);
          }
        } catch (localErr) {
          console.error('Failed to fetch local rates:', localErr);
          setError('Rs:106');
          setLoading(false);
        }
      }
    };

    fetchPrices();
  }, []);

  if (loading) {
    return <div className={mobile ? "loading-mobile" : "loading-desktop"}>...</div>;
  }

  if (error) {
    return <div className={mobile ? "error-mobile" : "error-desktop"}>{error}</div>;
  }

  return (
    <div className={`dropdown-container ${mobile ? 'mobile' : ''}`}>
      {!mobile && <div className="rate-label">Today's Rate:</div>}
      <div className="dropdown">
        <button className={`dropdown-toggle ${mobile ? 'mobile' : ''}`}>
          <span>{mobile ? `G :₹${prices.gold}` : `GOLD 1G: ₹${prices.gold}`}</span>
        </button>
      </div>
    </div>
  );
};

export default GoldRateDropdown;